import { Destination } from '../types/catalog'

/** Delivery addresses the desk can geocode, across the Puget Sound region. */
export const destinations: Destination[] = [
  { label: 'Renton, WA', zip: '98057', coords: { lat: 47.4829, lng: -122.2171 } },
  { label: 'Kent, WA', zip: '98032', coords: { lat: 47.3809, lng: -122.2348 } },
  { label: 'Tukwila, WA', zip: '98188', coords: { lat: 47.474, lng: -122.261 } },
  { label: 'Bellevue, WA', zip: '98004', coords: { lat: 47.6101, lng: -122.2015 } },
  { label: 'Issaquah, WA', zip: '98027', coords: { lat: 47.5301, lng: -122.0326 } },
  { label: 'Maple Valley, WA', zip: '98038', coords: { lat: 47.3923, lng: -122.0454 } },
  { label: 'Auburn, WA', zip: '98002', coords: { lat: 47.3073, lng: -122.2285 } },
  { label: 'Federal Way, WA', zip: '98003', coords: { lat: 47.3223, lng: -122.3126 } },
  { label: 'Seattle, WA', zip: '98104', coords: { lat: 47.6026, lng: -122.3284 } },
  { label: 'Sammamish, WA', zip: '98074', coords: { lat: 47.6163, lng: -122.0356 } },
  { label: 'Black Diamond, WA', zip: '98010', coords: { lat: 47.3087, lng: -122.0043 } },
  { label: 'Snoqualmie, WA', zip: '98065', coords: { lat: 47.5287, lng: -121.8254 } },
  { label: 'Everett, WA', zip: '98201', coords: { lat: 47.979, lng: -122.2021 } },
  { label: 'Tacoma, WA', zip: '98402', coords: { lat: 47.2529, lng: -122.4443 } },
  { label: 'Puyallup, WA', zip: '98371', coords: { lat: 47.1854, lng: -122.2929 } },
  { label: 'Redmond, WA', zip: '98052', coords: { lat: 47.674, lng: -122.1215 } },
  { label: 'Ravensdale, WA', zip: '98051', coords: { lat: 47.3596, lng: -121.9765 } },
  { label: 'Covington, WA', zip: '98042', coords: { lat: 47.3573, lng: -122.1218 } },
  { label: 'Enumclaw, WA', zip: '98022', coords: { lat: 47.2043, lng: -121.9915 } },
  { label: 'Burien, WA', zip: '98166', coords: { lat: 47.4704, lng: -122.3468 } },
]
